"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8234],{

/***/ 32952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pj": function() { return /* binding */ PRODUCT_QUERY; },
/* harmony export */   "YE": function() { return /* binding */ VARIANT_QUERY; }
/* harmony export */ });
/* unused harmony exports VARIANTS_QUERY, SIBLING_VARIANTS, PDP_QUERY, LAZY_PDP_QUERY, PRODUCT_SIZE_CHART_QUERY */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70463);
/* harmony import */ var gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19404);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Variants(\n    $input: VariantsInput!\n    $includeComparisonFields: Boolean = false\n  ) {\n    variants(input: $input) {\n      __typename\n      id\n      masterId\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n        bestPrice\n      }\n      ean\n      percentageDiscountBadge\n      name\n      variantId\n      header\n      subHeader\n      orderable\n      colorValue\n      colorName\n      displayOutOfStock {\n        displayValue\n      }\n      images {\n        href\n        alt\n      }\n      technology @include(if: $includeComparisonFields)\n      runTerrain @include(if: $includeComparisonFields)\n      weight @include(if: $includeComparisonFields)\n      heelToToeDrop @include(if: $includeComparisonFields)\n      fastener @include(if: $includeComparisonFields)\n      pronation @include(if: $includeComparisonFields)\n      refinementCushioningLevel @include(if: $includeComparisonFields)\n      runnerType @include(if: $includeComparisonFields)\n      mainMaterial @include(if: $includeComparisonFields)\n      cupType @include(if: $includeComparisonFields)\n      trouserRise @include(if: $includeComparisonFields)\n      pocketType @include(if: $includeComparisonFields)\n      apparelLength @include(if: $includeComparisonFields)\n      characteristics @include(if: $includeComparisonFields)\n      supportLevelBra @include(if: $includeComparisonFields)\n      studs @include(if: $includeComparisonFields)\n      playerLevel @include(if: $includeComparisonFields)\n      fit @include(if: $includeComparisonFields)\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query SiblingVariants($input: SiblingVariantsInput!) {\n    siblingVariants(input: $input) {\n      ...mandatoryVariantFields\n      badges {\n        id\n        label\n      }\n      percentageDiscountBadge\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n        bestPrice\n      }\n      displayOutOfStock {\n        soldout\n        soldoutWithRecommender\n        comingsoon\n        backsoon\n        presale\n        displayValue\n      }\n      orderable\n      promotions(page: ProductListingPage) {\n        id\n        calloutMessage\n      }\n      isAppExclusive\n      appOnlyDateTimeFrom\n      appOnlyDateTimeTo\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Variant($id: ID!) {\n    variant(id: $id) {\n      id\n      masterId\n      name\n      colorValue\n      styleNumber\n      size {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Product($id: ID!) {\n    product(id: $id) {\n      id\n      name\n      header\n      subHeader\n      orderable\n      displayOutOfStock {\n        displayValue\n      }\n      variations {\n        id\n        name\n        colorValue\n        colorName\n        preview\n        price\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n        }\n        orderable\n        sizeGroups {\n          label\n          description\n          sizes {\n            id\n            label\n            value\n            productId\n            orderable\n            maxOrderableQuantity\n          }\n        }\n        displayOutOfStock {\n          soldout\n          soldoutWithRecommender\n          comingsoon\n          backsoon\n          presale\n          displayValue\n          validTo\n        }\n        images {\n          href\n          alt\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PDP($id: ID!, $viewAt: String) {\n    product(id: $id) {\n      ...mandatoryMasterFields\n      productNameTranslated\n      description\n      primaryCategoryId\n      productDivision\n      brand\n      disableRatings\n      disableReviews\n      amountOfReviews\n      averageRating\n      sizeChartId\n      promotions(page: ProductDetailsPage) {\n        id\n        calloutMessage\n      }\n      configureID {\n        enabled\n        productID\n      }\n      productVideos\n      verticalProductVideos\n      promotionExclusion\n      exploreMoreCTALabel\n      showExploreCollectionCTA\n      exploreMoreCTATargetCategoryID\n      brand\n      orderable\n      fitOptions {\n        label\n        masterProduct {\n          id\n          name\n          variations {\n            id\n            colorValue\n            orderable\n          }\n        }\n      }\n      variations {\n        ...pdpMandatoryVariantFields\n        isFinalSale\n        returnRuleID\n        promotionExclusion\n        specialMessage(viewAt: $viewAt)\n        ean\n        validUntil\n        isAppExclusive\n        badges {\n          id\n          label\n        }\n        percentageDiscountBadge\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n          isSalePriceElapsed\n          tax\n          taxRate\n          bestPrice\n        }\n        styleNumber\n        materialComposition\n        displayOutOfStock {\n          soldout\n          soldoutWithRecommender\n          comingsoon\n          backsoon\n          presale\n          displayValue\n          validTo\n        }\n        orderable\n        modelMeasurementText\n        manufacturerInfo {\n          manufacturerAddress {\n            label\n            content\n          }\n          countryOfOrigin {\n            label\n            content\n          }\n        }\n        myCustomizer {\n          enabled\n          iframeID\n          startPoint\n        }\n        configureID {\n          enabled\n          productID\n        }\n        taxDisplayMsg\n        promotions(page: ProductDetailsPage) {\n          id\n          calloutMessage\n        }\n        appOnlyDateTimeFrom\n        appOnlyDateTimeTo\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query LazyPDP($id: ID!) {\n    product(id: $id) {\n      id\n      ...sizes\n      variations {\n        ...pdpMandatoryExtraVariantFields\n        description\n        productStory {\n          longDescription\n          materialComposition\n          careInstructions\n          manufacturerInfo {\n            manufacturerAddress {\n              label\n              content\n            }\n            countryOfOrigin {\n              label\n              content\n            }\n          }\n          productKeywords\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ProductSizeChart($id: [ID!]!) {\n    sizeCharts(ids: $id) {\n      id\n      name\n      body\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var VARIANTS_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
var SIBLING_VARIANTS = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .MANDATORY_VARIANT_FIELDS */ .EN);
var VARIANT_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var PRODUCT_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3());
var PDP_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4(), gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .PDP_MANDATORY_VARIANT_FIELDS */ .uQ, gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .MANDATORY_MASTER_FIELDS */ .YP);
// Lazy PDP query to fetch non-critical product data azynchronously after the page has loaded, reducing the initial render.
var LAZY_PDP_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5(), gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .PDP_MANDATORY_EXTRA_VARIANT_FIELDS */ .MI, gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .SIZES_FRAGMENT */ .gm);
var PRODUCT_SIZE_CHART_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject6());


/***/ }),

/***/ 53579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34209);






var Img = function(_param) {
    var src = _param.src, width = _param.width, _ratio = _param.ratio, ratio = _ratio === void 0 ? "1 / 1" : _ratio, className = _param.className, _loading = _param.loading, loading = _loading === void 0 ? "lazy" : _loading, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "ratio",
        "className",
        "loading"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ratio.split(" / ").map(Number), 2), horizontalRatio = ref[0], verticalRatio = ref[1];
    var decimalAspectRatio = verticalRatio / horizontalRatio;
    var height = width && width * decimalAspectRatio;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)("w-full bg-puma-black-800", "aspect-".concat(horizontalRatio, "-").concat(verticalRatio), className),
        src: src,
        width: width,
        height: height,
        loading: loading
    }, rest));
};


/***/ }),

/***/ 78234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PickUpWhereYouLeftOff": function() { return /* binding */ PickUpWhereYouLeftOff; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(25380);
/* harmony import */ var hooks_useLocation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60248);
/* harmony import */ var hooks_usePreferences__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89915);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20368);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79758);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68302);
/* harmony import */ var utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69377);
/* harmony import */ var gql_queries_product__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32952);
/* harmony import */ var utils_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75350);
/* harmony import */ var hooks_useSimpleCart__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85914);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53579);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6485);



















var PickUpWhereYouLeftOff = function() {
    var ref, ref1, ref2;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var countryCode = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_6__/* .useSiteConfig */ .N)().countryCode;
    var location = (0,hooks_useLocation__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)().location;
    var ref3 = location || {}, siteCountry = ref3.siteCountry, userCountry = ref3.userCountry;
    var ref4 = (0,hooks_usePreferences__WEBPACK_IMPORTED_MODULE_4__/* .usePreferences */ .Gn)(), preferences = ref4.preferences, setPreferences = ref4.setPreferences;
    var cart = (0,hooks_useSimpleCart__WEBPACK_IMPORTED_MODULE_12__/* .useSimpleCart */ .r)().cart;
    var lastViewedProduct = preferences["last-viewed-product"];
    // Don't show on the same product
    var differentProduct = router.query.id !== (lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.id);
    // Only show if lastProduct was in the same country as the site
    var sameCountry = (lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.country) === countryCode;
    // Only show if user has preferred the site region, or is already viewing their regional site
    var locationPopupHidden = preferences["prefers-region"] || (userCountry === null || userCountry === void 0 ? void 0 : userCountry.id) === (siteCountry === null || siteCountry === void 0 ? void 0 : siteCountry.id);
    var isInSameSessionAsSettingProduct = window.sessionStorage.getItem("in-session") === "true";
    // Check if we're on cart or checkout pages
    var isCartOrCheckoutPage = router.asPath.includes("/cart") || router.asPath.includes("/checkout");
    // Check if cart is empty
    var isCartEmpty = !(cart === null || cart === void 0 ? void 0 : cart.productCount);
    // Only hide the popup on cart/checkout pages when cart has items
    var shouldHideOnCurrentPage = isCartOrCheckoutPage && !isCartEmpty;
    var initialShouldShow = differentProduct && sameCountry && locationPopupHidden && !isInSameSessionAsSettingProduct && !shouldHideOnCurrentPage;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialShouldShow), shouldShow = ref5[0], setShouldShow = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_16__/* .useQuery */ .aM)({
        query: gql_queries_product__WEBPACK_IMPORTED_MODULE_10__/* .PRODUCT_QUERY */ .Pj,
        variables: {
            id: lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.id
        },
        pause: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .isServer */ .sk || !lastViewedProduct || !initialShouldShow
    }), 1), query = ref6[0];
    var clearLastViewedProduct = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setPreferences(function(curr) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, curr), {
                "last-viewed-product": undefined
            });
        });
    }, [
        setPreferences
    ]);
    var closePopup = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setShouldShow(false);
        clearLastViewedProduct();
    }, [
        clearLastViewedProduct
    ]);
    var product;
    if (lastViewedProduct && ((ref = query.data) === null || ref === void 0 ? void 0 : ref.product)) {
        var ref7;
        var productData = (ref7 = query.data) === null || ref7 === void 0 ? void 0 : ref7.product;
        if ((productData === null || productData === void 0 ? void 0 : productData.orderable) || (productData === null || productData === void 0 ? void 0 : productData.displayOutOfStock)) {
            var chosenVariant = productData === null || productData === void 0 ? void 0 : productData.variations.find(function(x) {
                return x.colorValue === (lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.swatch);
            });
            product = {
                name: productData.name,
                color: chosenVariant === null || chosenVariant === void 0 ? void 0 : chosenVariant.colorName,
                image: chosenVariant === null || chosenVariant === void 0 ? void 0 : chosenVariant.images[0],
                url: (0,utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_9__/* .buildProductUrl */ .B)(lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.id, productData === null || productData === void 0 ? void 0 : productData.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                    color: lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.swatch
                }, (lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.size) && {
                    size: lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.size
                }))
            };
        }
    }
    // This ensures shouldShow stays in sync with the calculated conditions
    // This fixes an issue where the popup would sometimes appear on cart/checkout pages even when initialShouldShow was false
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setShouldShow(initialShouldShow);
    }, [
        initialShouldShow
    ]);
    // cleanup preferences if the query fails
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (query.error) {
            clearLastViewedProduct();
        }
    }, [
        query.error,
        clearLastViewedProduct
    ]);
    // close popup after N seconds
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (product) {
            var timeout = setTimeout(function() {
                if (product) closePopup();
            }, 10000);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        product,
        closePopup
    ]);
    // render nothing unless we have a product to show
    if (!(product && shouldShow)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed right-0 bottom-0 z-[80] p-2 sm:p-5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-white shadow-2xl p-5 space-y-3 border rounded-lg font-display max-w-sm",
            "data-test-id": "pickup-where-you-left-off",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "font-bold uppercase",
                            children: t("pickUpWhereYouLeftOff")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: "absolute right-0 mr-7 sm:mr-10 opacity-60",
                            onClick: closePopup
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "border p-4 space-y-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-10 gap-4 xs:gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full self-center flex-none col-span-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_13__/* .Img */ .E, {
                                    src: (0,utils_image__WEBPACK_IMPORTED_MODULE_11__/* .resizeProductImage */ .QW)((ref1 = product.image) === null || ref1 === void 0 ? void 0 : ref1.href, 250),
                                    width: 250,
                                    alt: ((ref2 = product.image) === null || ref2 === void 0 ? void 0 : ref2.alt) || product.name
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "m-auto col-span-6 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "font-bold text-puma-black leading-tight -mt-4",
                                        children: product.name
                                    }),
                                    product.color && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-xs xs:text-sm",
                                        "data-test-id": "color",
                                        children: [
                                            t("pickUpWhereYouLeftOffColorPre") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: t("pickUpWhereYouLeftOffColorPre")
                                            }),
                                            " ",
                                            product.color
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_8__/* .Link */ .r, {
                    as: "button",
                    variant: "primary",
                    className: "w-full",
                    onClick: closePopup,
                    "data-test-id": "view-product",
                    href: product.url,
                    children: t("viewProduct")
                })
            ]
        })
    });
};


/***/ })

}]);